import subscriptions from './subscriptions'
import fetchesAllPaginatedUsers from './fetchesAllPaginatedUsers'

export const providesUsersSubscriptions = subscriptions

export default fetchesAllPaginatedUsers(function() {
  // we don't need to render a thing
  return null
})
